import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';
import {
  Environment,
  Macchine,
  ModelNumStr,
  IMacchine_TableModel,
  ModelNumStrNav,
  NgPrintQrModel,
} from '../../models/-index';

@Injectable()
export class MacchineService extends CrudGenericsService<Macchine, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Macchine`);
    this.base = `${env.apiUrl}/api/Macchine/`;
  }

  Get4Select_ByDiv(div: number = 0): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_ByDiv?div=${div}`;
    return this.http.get<ModelNumStr[]>(u);
  }
  Get4Select_ByReparto(rep: number): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_ByReparto?rep=${rep}`;
    return this.http.get<ModelNumStr[]>(u);
  }
  Get4Select_ByPostazione(pos: number): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_ByPostazione?pos=${pos}`;
    return this.http.get<ModelNumStr[]>(u);
  }
  Get4Select_PostazioneNavigation(): Observable<ModelNumStrNav[]> {
    const u = `${this.base}Get4Select_PostazioneNavigation`;
    return this.http.get<ModelNumStrNav[]>(u);
  }
  GetMacchine_TableModel(): Observable<IMacchine_TableModel[]> {
    const u = `${this.base}GetMacchine_TableModel`;
    return this.http.get<IMacchine_TableModel[]>(u);
  }
  // print etichetta
  GetNgPrintQrModel(id): Observable<NgPrintQrModel> {
    const u = `${this.base}GetNgPrintQrModel?id=${id}`;
    return this.http.get<NgPrintQrModel>(u);
  }
}
